<template>
  <div>
    <div class="h-dialogContainer" >
      <template>
        <ParseForm ref="basic" :formId="formItems.basic.formId" :formParams="formItems.basic.formObj" :opCode="opCode" :funcClick="bindClickInterface" :funcOnChange="changeOdbStatus"></ParseForm>
      </template>
      <template>
        <ParseList ref="addr" :formId="formItems.addr.formId" :formParams="formItems.addr.formObj" :Title="formItems.addr.title" :opCode="opCode"
          :funcClick="bindClickOnAddrList" :maxLength="formItems.addr.maxLength" :minLength="formItems.addr.minLength" >
        </ParseList>
      </template>
      <ProfileList ref='profileList' :getCheckedDatas='getCheckedList' :ne="ne"></ProfileList>
      <PdnProfileList ref='pdnProfileList' :getCheckedDatas='getPdnCheckedList' :ne="ne"></PdnProfileList>
    </div>
  </div>
</template>

<script>
import ParseForm from '../../../util/parseFormNew/ParseForm';
import ProfileList from "./ProfileList";
import PdnProfileList from "./PdnProfileList";
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import ParseList from '../../../util/parseFormNew/ParseList';
import ajaxUrl from "../../../data/ajaxUrl";
import { EventBus } from '../../../../../plugins/eventBus';

export default {
  name: "ModUserForm",
  components: {
    ParseForm,
    ProfileList,
    PdnProfileList,
    ParseList,
  },
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.basic) {
        if (!this.$refs.basic.validateResult()) {

          return;
        }
        const maps = this.$refs.basic.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      if (this.$refs.addr) {
        if (!this.$refs.addr.validateResult()) {

          return;
        }
        const addr = this.$refs.addr.getDatas();
        if (addr) {
          let flag = false;
          addr.list.forEach((item) => {
            if(item.ipv4_addr === '' && !flag) {
              flag = true;
              EventBus.$emit('toast', {type: 'warning', content: this.$t("LteUser.ipv4InfoCantEmpty")});
            }
          });
          if (flag) {
            return;
          }
          map.set('staAddrConfig', addr.list);
        }
      }
      console.log(map);
      return map;
    },
    saveUser(ne, callback) {
      const formData = this.getDatas();
      if (formData) {
        this.$loading.showLoadding(this.$t('MML.loadingTip'));
        const staAddrConfig = formData.get("staAddrConfig");
        staAddrConfig.map(item => {
          item.ip_addr_type = 0;
          if (item.ipv4_addr) {
            item.ip_addr_type = 0;
          }else if (item.ipv6_addr) {
            item.ip_addr_type = 1;
          }
        });
        const params = {
          vo: {
            "neid": ne.neid,
            "isBatch": "0",
            "grpid": "0",
            "imsi_odb": formData.get("imsi_status") === 1 ? formData.get("imsi_odb") : '',
            "imsi": formData.get("imsi"),
            "msisdn": formData.get("msisdn"),
            "k": formData.get("k"),
            "amf": formData.get("amf"),
            "op": formData.get("op"),
            "imsi_status": formData.get("imsi_status"),
            "profile_id": formData.get("profile_id"),
            "staticAddrCount": staAddrConfig.length,
            "staAddrConfig": staAddrConfig,
            "randKeyFlg": 0,
          },
          info: {
            msgid: this.msgId,
            neid: ne.neid,
          },
          log: {
            module: 'res.subscriber#res.subscriber_lte#res.subscriber_lte_user',
            execFunName: 'subscriber.modUser',
            exectype: 1,
            execData: [formData.get("imsi")]
          }
        };
        this.$axios.post(ajaxUrl.requestCommon, params).then((response) => {
          this.$loading.hideLoadding();
          if (callback) {
            callback(response);
          }
        });
      }
    },
    UpdateStaAddrConfig(json) {
      return json.map((item)=>{
        if (item.id === "staAddrConfig") {
          return {
            ...item,
            "attrList": [
              {
                "modifyShow":false,
                "type":"",
                "batch_hidden":true,
                "tempFlag":false,
                "changeClick":false,
                "groupBy":item.groupBy,
                "id":"count",
                "couldMod":false,
                "showName":this.$t("LteUser.staticAddrNum"),
                "hidden":true,
                "name":"count",
                "value":"",
                "uiIndex":item.uiIndex,
                "require":false,
                "couldBatchMod":false
              },
              {
                "modifyShow":false,
                "type":"",
                "batch_hidden":true,
                "tempFlag":false,
                "changeClick":false,
                "groupBy":item.groupBy,
                "id":"list",
                "couldMod":false,
                "showName":this.$t("LteUser.configStaticIP"),
                "hidden":true,
                "name":"list",
                "value":"",
                "uiIndex":item.uiIndex,
                "require":false,
                "attrList":	item.attrList,
                "couldBatchMod":false
              }
            ]
          }
        }
        else {
          return item;
        }
      })
    },
    getJson(ne, checkedDatas, callback) {
      this.ne = ne;
      const params = {
        msgid: this.msgId,
        neid: ne.neid,
      };
      console.log('checkedDatas',checkedDatas);
      const staAddrConfig = checkedDatas[0].staAddrConfig.filter((item) => {
        return (item.pdnProfileID != 0 && item.pdnProfileID != '');
      });
      const checkedRecord = {
        ...checkedDatas[0],
        staAddrConfig: {
          count: staAddrConfig.length,
          list: staAddrConfig,
        }
      };
      this.profileId = checkedDatas[0].profile_id;
      this.$axios.post(ajaxUrl.modLteUserJson, params).then(response => {
        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("getJson response.data.errorCode error");
          callback(response);
          return;
        }
        if (checkedRecord.imsi_status === 1) {
          jsonObj.forEach((item) => {
            if (item.name === 'imsi_odb') {
              item.readonly = false;
            }
          })
        }
        const jsonObj = this.UpdateStaAddrConfig(response.data.resultVal);
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(jsonObj, checkedRecord);
        this.formItems.basic.formObj = resultMap.get(this.formItems.basic.modelName);
        this.formItems.addr.formObj = resultMap.get(this.formItems.addr.modelName);
        callback(response);
      });
    },
    getCheckedList(list) {
      this.$refs.basic.setData('profile_id', list[0] || '');
      this.$refs.basic.validateResult(['profile_id']);
      this.profileId = list[0] || '';
    },
    getPdnCheckedList(list) {
      this.$refs.addr.setData(this.$refs.addr.getClickIndex(), 'pdnProfileID', list[0].profileId || '');
    },
    onclickProfileId() {
      this.$refs.profileList.qryList(this.ne);
      this.$refs.profileList.show(this.$refs.basic);
    },
    onclickPdnProfileId() {
      this.$refs.pdnProfileList.qryList(this.ne, this.profileId);
      this.$refs.pdnProfileList.show();
    },
    // 绑定
    changeOdb() {
      const newValue = this.$refs.basic.getAttrByName('imsi_status', 'value');
      if (newValue === 1) {
        this.$refs.basic.setAttrByName('imsi_odb', 'readonly', false);
      } else {
        this.$refs.basic.setAttrByName('imsi_odb', 'readonly', true);
      }
    }
  },
  computed: {
    bindClickOnAddrList() {
      this.funcMap2 = new Map();
      this.funcMap2.set('pdnProfileID', () => { this.onclickPdnProfileId(); });
      return this.funcMap2;
    },
    bindClickInterface() {
      this.funcMap1 = new Map();
      this.funcMap1.set('profile_id', () => { this.onclickProfileId(); });
      return this.funcMap1;
    },
    changeOdbStatus() {
      this.funcMap3 = new Map();
      this.funcMap3.set('imsi_status', this.changeOdb);
      return this.funcMap3;
    }
  },
  data() {
    return {
      ne: null,
      profileId: '',
      funcMap1: null,
      funcMap2: null,
      funcMap3: null,
      formItems: {
        basic: {
          formId: "LteModBasicInfo",
          modelName: "basic",
          formObj: null,
        },
        addr: {
          title: this.$t("LteUser.staticAddr"),
          formId: "LteModStaticAddrInfo",
          modelName: "addr",
          formObj: null,
          maxLength: 5,
          minLength: 0,
        },
      },
      opCode: "mod",
      msgId: "17062",
    };
  },
  beforeDestroy() {
  }
};
</script>

